/**
 * @generated SignedSource<<e33fae9cfbee9972b266786486525b14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CourseCard_course$data = {
  readonly courseImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly description: string | null | undefined;
  readonly facility: {
    readonly address: string | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"CourseCardCourseNote_course" | "CourseCardSummary_course" | "useCourseDisplayName_course">;
  readonly " $fragmentType": "CourseCard_course";
};
export type CourseCard_course$key = {
  readonly " $data"?: CourseCard_course$data;
  readonly " $fragmentSpreads": FragmentRefs<"CourseCard_course">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CourseCard_course",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCourseDisplayName_course"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CourseCardSummary_course"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CourseCardCourseNote_course"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "courseImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Course",
  "abstractKey": null
};

(node as any).hash = "e7861a919988bdeec31b7a046dc53dfe";

export default node;
